<template>
	<div  class="userManager componetself">
		<div class="body_btns headbtn">
			<vxe-button type="text" class="tool-btn _icon_button" :loading="qyload" :disabled="qyload" title="启用" @click="USERCHANGE(0)">
				<i class="el-icon-s-claim iconSize "></i>启用
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" :loading="banLoad" :disabled="banLoad" title="禁用" @click="USERCHANGE(3)">
				<i class="el-icon-s-release iconSize "></i>禁用
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" :loading="RePassLoad" :disabled="RePassLoad" title="重置密码" @click="ReSetPass">
				<i class="iconfont icon-recovery iconSize "></i>重置密码
			</vxe-button>
		</div>
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  filterList">
					<div class="filter_item" :key="index">
						<c-filter :item="item" 
							:form="filterForm" :line="true" :textMini="45"></c-filter>
					</div>
				</template>
			</div>
			<div class="btns">
				<el-button type="primary" class="pursh_mainBtn" :loading="selectLog" :disabled="selectLog" @click="selectUSER">查询</el-button>
			</div>
		</div>
		<div  class="componet_body">
			<div class="body_content">
				<c-table key="0" ref="ctablemain" :table="table" :coltype="'checkbox'"  :calculate="false"
					@listenToChild="listenToChild"
					@FitColumns="table.head=$event"></c-table>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				filterForm:{},
				selectLog:false,
				table: {
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
				},
				checkList:[],
				RePassLoad:false,
				qyload:false,
				banLoad:false
			}
		},
		computed:{
			filterList(){
				return [
					{
						name:'编号',
						Display:'编码',
						type:1
					},
					{
						name:'名称',
						Display:'名称',
						type:1
					},
					{
						name:'状态',
						Display:'状态',
						type:2,
						dataSource:[
							{value:'',item:'全部'},
							{value:'未启用',item:'未启用'},
							{value:'启用',item:'启用'},
						],
						valueName:'value',
						displayName:'item'
					},
				]
			},
			tableHead(){
				return [
					{
						name:'编号',
						title:'编码',
						width:80,
						hide:false
					},
					{
						name:'名称',
						width:80,
						title:'名称',
						hide:false
					},
					{
						name:'状态',
						width:80,
						title:'状态',
						hide:false
					},
				]
			},
			userinfo() {
				return this.$store.getters.UserInfo;
			},
		},
		methods:{
			listenToChild(e){
				if(e&&e['checkList']) this.checkList=e['checkList'];
			},
			//重置密码
			ReSetPass(){
				try{
					if(this.checkList.length==0) throw '请先选择用户';
					if(this.RePassLoad) return;
					this.RePassLoad=true;
					let fusers=[];
					for(let i in this.checkList){
						let item=this.checkList[i];
						if(item['状态']=='未启用')
							throw `编号 ${item['编号']} 用户当前为 未启用状态 不需要重置密码`;
						fusers.push(item['编号']);
					}
					
					this.$BH().base.http({
						url:'Web/USERPASSINIR',
						data:{
							FUSERS:fusers,
							FUSER:this.userinfo.fnumber
						},
						success:(res)=>{
							this.$BH().message('重置成功');
						},
						loadingcontrol:()=>{
							this.RePassLoad=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.RePassLoad=false;
					this.$BH().message(e);
				}
			},
			selectUSER(){
				try{
					if(this.selectLog) return;
					this.selectLog=true;
					this.$BH().base.http({
						url:'Web/USERGET',
						data:{
							filterList:this.filterList,
							filterform:this.filterForm
						},
						success:(res)=>{
							let {value}=res.data;
							this.table.data=value;
							this.checkOne={};
							if(value.length>0)
								this.$refs.ctablemain?.updateCoulm();
							this.$refs.ctablemain?.clearSelection();
						},
						loadingcontrol:()=>{
							this.selectLog=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.selectLog=false;
				}
			},
			USERCHANGE(e){
				try{
					
					if(this.checkList.length==0) throw '请先选择用户';
					if(e==0){
						if(this.qyload) return;
						this.qyload=true;
					}else if(e==3){
						if(this.banLoad) return;
						this.banLoad=true;
					}else return;
					let fusers=[];
					for(let i in this.checkList){
						let item=this.checkList[i];
						console.log(item)
						if(item['状态']=='未启用'&&e==3)
							throw `编号 ${item['编号']} 用户不需要 重复禁用`;
						else if(item['状态']=='启用'&&e==0)
							throw `编号 ${item['编号']} 用户不需要 重复启用`;
						fusers.push(item['编号']);
					}
					this.$BH().base.http({
						url:'Web/USERCHANGE',
						data:{
							FUSER:this.userinfo.fnumber,
							FSTATE:e,
							FUSERS:fusers
						},
						success:(res)=>{
							if(e==0)
								this.$BH().message('启用成功');
							else this.$BH().message('禁用成功');
							//刷新数据
							this.selectUSER();
						},
						loadingcontrol:()=>{
							this.qyload=false;
							this.banLoad=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.qyload=false;
					this.banLoad=false;
				}
			}
		},
		created() {
			this.table.head=this.tableHead;
		}
	}
</script>

<style>
</style>